import {Component, OnDestroy, OnInit } from '@angular/core';
import {Game, Games} from "../../../models/game.class";
import {GameService} from "../../../services/game.service";
import {catchError, of, Subscription, switchMap, tap} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {TitleService} from "../../../services/title.service";
import {UserModel} from "../../../models/user.model";
import {UserService} from "../../../services/user.service";
import {TrackingHelperService} from "../../../services/tracking-helper.service";
import {PromotionService} from "../../../services/promotion.service";
import {AuthService} from "../../../services/auth.service";

// import Fuse from "fuse.js"; //TODO implement fuse in searchbar


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit, OnDestroy {

  titleTranslateSubs?: Subscription;

  user: UserModel | null = null;
  userSubs?: Subscription;
  userHasTracker: boolean;
  userHasActivePromo: boolean = false;
  forPromoSubs?: Subscription;

  games?: Games;
  gameSubscription?: Subscription;

  categories: string[];
  randomGamesByCategoryForCarousels: Game[][] = [];

  readonly displayedCategories: string[] = ['all', 'exclusive', 'new', 'top', 'live', 'featured', 'specialty']; //on display in tabs

  readonly itemsPerPage = 12;
  itemsToShowInLobby?: number = undefined;
  gamesToDisplayByCategory: Game[][] = [];

  searchTerm: string = '';
  filteredGamesByCategory: Game[][] = []

  //TODO fuse
  // fuse: any;
  // fuseResults: any[] = [];
  // fuseOptions = {
  //   // isCaseSensitive: false,
  //   // includeScore: false,
  //   includeScore: true,  // Helps filter out bad matches
  //   // ignoreDiacritics: false,
  //   // shouldSort: true,
  //   // includeMatches: false,
  //   // findAllMatches: false,
  //   findAllMatches: true, // Returns all occurrences of the search term
  //   // minMatchCharLength: 1,
  //   minMatchCharLength: 2,  // Allows short searches like 'di'
  //   // location: 0,
  //   // threshold: 0.6,
  //   threshold: 0.4,  // Lower = stricter matches
  //   // distance: 100,
  //   distance: 50, // Prevents characters being too far apart in matches
  //   // useExtendedSearch: false,
  //   // ignoreLocation: false,
  //   ignoreLocation: true, // Matches anywhere in the word
  //   // ignoreFieldNorm: false,
  //   // fieldNormWeight: 1,
  //   shouldSort: true,  // Sorts by best match
  //   keys: [  // Search in game names and tags
  //     "name",
  //     // "category",
  //     "tags"
  //   ]
  // };


  constructor(
    private gameService: GameService,
    private translate: TranslateService,
    private titleService: TitleService,
    private userService: UserService,
    private promoService: PromotionService,
    private authService: AuthService,
    private trackingService: TrackingHelperService
  ) {
    this.categories = this.gameService.categories;

    this.userHasTracker = !!this.trackingService.getTracker();

    this.userSubs = this.userService.userObject.subscribe(user => {
      this.user = user
    })


    //to check if the user has any active promotions
    this.forPromoSubs = this.authService.token.pipe(
      switchMap(t => t ? this.promoService.getUserPromos() : of([])),
      catchError(err => {
        console.error('Error fetching promotions:', err.message || err);
        return of([]);
      })
    ).subscribe(data => {
      if (data.length){
        const activePromotions = data.filter(p => p.state === 'active');
        this.userHasActivePromo = !!activePromotions.length;
      } else {
        this.userHasActivePromo = false;
      }
    })

    this.titleTranslateSubs?.unsubscribe();
    this.titleTranslateSubs = this.translate.stream("HOME.PAGE_TITLE").subscribe(data => {
      this.titleService.setTitle(`Lobby / ${data}`);
    })

  }

  ngOnInit() {
    this.gameSubscription = this.gameService.getGames().subscribe(games => {
      // games: we will get a gameList from service or an empty [] - we want them in order of 'sort' from cdn:
      this.games = Games.fromGameArray(games.getMostPlayed())
      // console.log(this.games)

      //set games for carousels
      this.randomGamesByCategoryForCarousels = this.gameService.categories.map(catName => this.games?.getGamesOfCategory(catName) ?? []).map(category => this.gameService.pickRandomGames(category, 16))

      //to show games
      this.loadItems();

    })

  }


  loadItems() {
    this.filterGames();
    // console.log(this.filteredGamesByCategory)

    this.gamesToDisplayByCategory = this.filteredGamesByCategory.map((categoryGames,index) => {
      if (index === 0 && this.itemsToShowInLobby) {
        return categoryGames.slice(0, this.itemsToShowInLobby);
      }
      return categoryGames.slice(0, this.itemsPerPage);
    })
  }


  filterGames() {
    //to show only displayed category games - filter by searchTerm if any + sorted by 'enabled' first
    const searchTerm = this.searchTerm?.trim().toLowerCase();
    this.filteredGamesByCategory = this.displayedCategories.map(catName => {
      let gamesOfCategory = this.games?.getGamesOfCategory(catName) ?? [];

      if(searchTerm){
        gamesOfCategory = gamesOfCategory.filter(game => game.name.toLowerCase().includes(searchTerm))
      }
      // Sort games by `enabled` property - games without enabled property will be treated as false in the sort
      return gamesOfCategory.slice().sort((a, b) => (b.enabled ? 1 : 0) - (a.enabled ? 1 : 0));
    });


    //TODO fuse in filter games + decide how to filter
    //TODO fuse - use fuse.js for filtering from searchbar
    // if (this.games){
    //   this.fuse = new Fuse(this.games.all, this.fuseOptions)
    //   this.fuseResults = this.fuse.search(searchTerm).filter((result: any) => result.score < 0.4);
    //   console.log(this.fuseResults.map((r:any)=>r.item.name))
    //   console.log(this.fuseResults)
    // }

  }

  onSearchChange(searchTerm: string) {
    this.searchTerm = searchTerm;
    this.loadItems();
  }

  loadMore(itemsToShow: number) {
    this.itemsToShowInLobby = itemsToShow;
    this.loadItems();
  }


  ngOnDestroy() {
    this.gameSubscription?.unsubscribe();
    this.titleTranslateSubs?.unsubscribe();
    this.forPromoSubs?.unsubscribe();

  }


}
